import { useEffect } from "react";

type TireSizeHelpPopupProps = {
    showPopup: boolean;
    setShowPopup: (value: boolean) => void;

}

export const TireSizeHelpPopup = ({ showPopup, setShowPopup }: TireSizeHelpPopupProps) => {


    useEffect(() => {
        if (showPopup) {
            document.body.classList.add("overflow-hidden");
        } else {
            document.body.classList.remove("overflow-hidden");
        }

        return () => document.body.classList.remove("overflow-hidden");
    }, [showPopup]);

    if (!showPopup) return null;

    return (
        <div className="fixed inset-0 z-[9999999] flex items-center justify-center bg-black/60 px-4 overflow-y-auto">
            <div className="w-full max-w-2xl mx-4 bg-white p-6 rounded-xl shadow-lg my-4">
                {/* Close button */}
                <div className="flex justify-end">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320.591 320.591"
                        className="w-4 h-4 cursor-pointer fill-gray-600"
                        onClick={() => setShowPopup(false)}
                    >
                        <path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z" />
                        <path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z" />
                    </svg>
                </div>
                {/* Content */}
                <div className="space-y-2 mt-2">
                    {/* Description */}
                    <p className="text-center text-sm text-gray-700 leading-relaxed">
                        There are two places to find your tire size: on the{" "}
                        <span className="font-semibold">side of the tire</span> or on a{" "}
                        <span className="font-semibold">
                            sticker inside the driver’s door jamb
                        </span>.
                        The sticker shows your vehicle’s original tire size and whether it
                        has staggered tires.
                    </p>

                    {/* Tire image */}
                    <div className="flex flex-col items-center">
                        <p className="mb-2 text-sm font-semibold">Passenger Tire</p>
                        <img
                            src="/images/tiresizehelp1.png"
                            alt="Tire size example"
                            className="rounded w-[320px]"
                        />
                    </div>

                    <div className="flex flex-col items-center">
                        <p className="text-center text-sm font-semibold">
                            Tire Placard: Inside front door jamb
                        </p>
                        <img
                            src="/images/tiresizehelp2.png"
                            alt="Tire size jamb example"
                            className="rounded w-[320px]"
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}